import React, { type FC } from "react";
import { Card } from "react-bootstrap";

interface ContactCardProps {
	className?: string;
	icon: React.ReactNode;
	title: string;
	children: React.ReactNode;
}

export const ContactCard: FC<ContactCardProps> = ({ className, icon, title, children }) => {
	return (
		<Card className={className}>
			<Card.Body className="p-4">
				<div className="mb-4">{icon}</div>
				<h2 className="mb-3">{title}</h2>
				<p className="mb-0">{children}</p>
			</Card.Body>
		</Card>
	);
};
